<template>
  <div class="container-fluid">
    <div class="card-body py-4">

      <div class="row mb-10">
        <div class="d-flex justify-content-end">
          <button data-bs-target="#importQuestionModal" data-bs-toggle="modal"  class="btn btn-sm btn-primary me-2">
            <i class="fas fa-arrow-down"></i>
            {{ $t('qvct_survey.import') }}
          </button>

          <button data-bs-target="#createQuestionModal" data-bs-toggle="modal" class="btn btn-sm btn-primary">
            <i class="fas fa-plus"></i>
            {{ $t('qvct_survey.new_field') }}
          </button>
        </div>
      </div>

      <div class="row">
        <SurveyField v-for="question in questions" :question="question" :key="question.id" @editField="editField"/>
      </div>


      <div v-if="!questions.length" class="row text-center justify-content-center align-items-center"
           style="height :60vh !important;width: 100%!important;">
        <div class=" text-center ">
          <div class="pt-8 ">
            <Img filename="empty.png" alt=""
                 class="mw-100 h-150px h-sm-225px" />
          </div>
          <h2 class="fs-2x fw-bolder mb-0">{{ $t('qvct_survey.no_fields_found') }}</h2>
          <p class="text-gray-400 fs-4 fw-bold py-7">{{ $t('button.clic') }}<br /></p>
          <button data-bs-target="#createQuestionModal" data-bs-toggle="modal" class="btn btn-sm btn-primary">
            <i class="fas fa-plus"></i>
            {{ $t('qvct_survey.new_field') }}
          </button>
        </div>
      </div>

      <div v-if="questions.length > 5" class="row mb-10">
        <div class="d-flex justify-content-end">
          <button data-bs-target="#createQuestionModal" data-bs-toggle="modal" class="btn btn-sm btn-primary">
            <i class="fas fa-plus"></i>
            {{ $t('qvct_survey.new_field') }}
          </button>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="createQuestionModal" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <form @submit.prevent="submitQuestion">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title">{{ $t("qvct_survey.create_field") }}</h3>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times fs-1"></i>
              </div>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                <TextArea
                    :label="$t('nps.form.label')"
                    :placeholder="$t('nps.form.label')"
                    :rows="2"
                    :isRequired="true"
                    v-model="formData.label"
                />
                </div>
                <div class="col-3">
                  <Select2
                      :name="'type'"
                      :multiple="false"
                      :label="$t('qvct_survey.form.response_type')"
                      :isRequired="true"
                      v-model="formData.type"
                  >
                    <option v-for="type in qvctSurveyTypes" :key="type.value" :value="type.value">
                      {{ type[locale] }}
                    </option>
                  </Select2>
                </div>

                <div class="col-9">
                  <Select2
                      :name="'questionCategories'"
                      :multiple="true"
                      :label="$t('qvct_survey.form.category')"
                      :isRequired="false"
                      v-model="formData.qvct_survey_category_id"
                      :closeOnSelect="false"
                  >
                    <optgroup v-for="options in categoriesOptionGroup" :key="options.id" :label=" options.title + ' - ' + options.parent_type">
                      <option v-for="category in options.data" :value="category.id"> {{ category.name }} </option>
                    </optgroup>
                  </Select2>
                </div>

                <div v-if="showOpt" class="col-12">
                  <Select2
                      :name="'questionResponseType'"
                      :multiple="false"
                      :label="$t('qvct_survey.form.answer_type')"
                      :isRequired="true"
                      v-model="formData.answer_type_id"
                  >
                    <option v-for="answerType in answersTypes" :value="answerType.id" :key="answerType.id"> {{ answerType.name }} </option>
                  </Select2>
                </div>

                <BooleanInput class="mb-3" classname="m" name="required" v-model="formData.required" label="qvct_survey.form.required" :required="false"/>
                <BooleanInput classname="n" name="negative" v-model="formData.negative" label="qvct_survey.form.negative" :required="false"/>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                {{ $t('button.close') }}
              </button>
              <Button :is-loading="isLoading" type="submit" btnClass="btn py-2 btn-primary" :btn-text="$t('button.save')"/>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="editQuestionModal" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <form @submit.prevent="updateQuestion">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title">{{ $t("qvct_survey.edit_field") }}</h3>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times fs-1"></i>
              </div>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                <TextArea
                    name="edit_label"
                    :label="$t('nps.form.label')"
                    :placeholder="$t('nps.form.label')"
                    :rows="2"
                    :isRequired="true"
                    v-model="formEditData.label"
                />
                </div>
                <div class="col-3">
                  <Select2
                      name="edit_type"
                      :multiple="false"
                      :label="$t('qvct_survey.form.response_type')"
                      :isRequired="true"
                      v-model="formEditData.type"
                  >
                    <option v-for="type in qvctSurveyTypes" :key="type.value" :value="type.value">
                      {{ type[locale] }}
                    </option>
                  </Select2>
                </div>

                <div class="col-9">
                  <Select2
                      name="editQuestionCategories"
                      :multiple="true"
                      :label="$t('qvct_survey.form.category')"
                      :isRequired="false"
                      v-model="formEditData.qvct_survey_category_id"
                      :closeOnSelect="false"
                  >
                    <optgroup v-for="options in categoriesOptionGroup" :key="options.id" :label=" options.title + ' - ' + options.parent_type">
                      <option v-for="category in options.data" :value="category.id"> {{ category.name }} </option>
                    </optgroup>
                  </Select2>
                </div>

                <div v-if="showEditOpt" class="col-9">
                  <Select2
                      name="editQuestionResponseType"
                      :multiple="false"
                      :label="$t('qvct_survey.form.answer_type')"
                      :isRequired="true"
                      v-model="formEditData.answer_type_id"
                  >
                    <option v-for="answerType in answersTypes" :value="answerType.id" :key="answerType.id"> {{ answerType.name }} </option>
                  </Select2>
                </div>
                <div v-if="showEditOpt" class="col-3">
                  <Input
                      type="number"
                      name="name"
                      :label="$t('qvct_survey.form.order')"
                      v-model="formEditData.order"
                      :isRequired="false"
                  />
                </div>

                <BooleanInput class="mb-3" classname="m" name="required" v-model="formEditData.required" label="qvct_survey.form.required" :required="false"/>
                <BooleanInput classname="n" name="negative" v-model="formData.negative" label="qvct_survey.form.negative" :required="false"/>

              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                {{ $t('button.close') }}
              </button>
              <Button :is-loading="isLoading" type="submit" btnClass="btn py-2 btn-primary" :btn-text="$t('button.save')"/>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="importQuestionModal" data-bs-backdrop="static">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title"> {{$t('exports.text') }}</h3>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x">
                  <i class="fa fa-times"></i>
              </span>
            </div>
          </div>
          <div class="modal-body">

            <button @click.prevent="downloadExcel"  v-if="$can('contact_export')" type="button" class="btn btn-bg-secondary w-100 mb-5" :data-kt-indicator="isLoadingDownload ? 'on': ''" :disabled="isLoadingDownload">
                        <span class="indicator-label">
                          <svg width='20px' height='20px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
                                <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                                    <g id='download_2_fill' fill-rule='nonzero'>
                                        <path d='M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z' id='MingCute' fill-rule='nonzero'></path><path d='M20,14.5 C20.8284,14.5 21.5,15.1716 21.5,16 L21.5,20 C21.5,21.3807 20.3807,22.5 19,22.5 L5,22.5 C3.61929,22.5 2.5,21.3807 2.5,20 L2.5,16 C2.5,15.1716 3.17157,14.5 4,14.5 C4.82843,14.5 5.5,15.1716 5.5,16 L5.5,19.5 L18.5,19.5 L18.5,16 C18.5,15.1716 19.1716,14.5 20,14.5 Z M12,1.5 C12.8284,1.5 13.5,2.17157 13.5,3 L13.5,12.0355 L15.182,10.3535 C15.7678,9.76776 16.7175,9.76776 17.3033,10.3535 C17.8891,10.9393 17.8891,11.8891 17.3033,12.4749 L13.2374,16.5407 C12.554,17.2242 11.446,17.2242 10.7626,16.5407 L6.6967,12.4749 C6.11091,11.8891 6.11091,10.9393 6.6967,10.3535 C7.28249,9.76776 8.23223,9.76776 8.81802,10.3535 L10.5,12.0355 L10.5,3 C10.5,2.17157 11.1716,1.5 12,1.5 Z' fill='#09244BFF'></path>
                                    </g>
                                </g>
                            </svg>
                        {{ $t('products.download_model') }}
                        </span>

              <span class="indicator-progress">
                            {{ $t('loading') }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
            </button>

            <div class="fv-row fv-plugins-icon-container mb-5" v-if="$can('contact_import')">
              <label class="form-label"></label>
              <div class="d-flex justify-content-center align-items-center">
                <input v-on:change="onQuestionFileChange" ref="usersFile" class="form-control form-control-solid border border-2" type="file" id="usersFile">
              </div>
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>

          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
            <Button :is-loading="isLoading" btn-class="btn-sm" type="new" btn-text="button.save" size="7px 30px" @click="importQuestion"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Button from "@/components/Button.vue";
import SurveyField from "@/Modules/Qvct/views/Survey/components/SurveyField.vue";
import Select2 from "@/components/Select2.vue";
import {useFormFieldTypes} from "@/composables/form/useFormFieldTypes";
import {useLocales} from "@/composables/locales";
import TextArea from "@/components/TextArea.vue";
const { qvctSurveyTypes } = useFormFieldTypes()
const { locale } = useLocales()
import {slugify} from '@/mixins/Helpers'
import {storeQuestion} from "@/Modules/Qvct/store/modules/qvctSurvey/actions";
import Img from "@/components/Img.vue";
import { createFormData } from "@/mixins/Helpers";
import BooleanInput from "@/components/Form/BooleanInput.vue";
import Input from "@/components/Input.vue";
import InputNumber from "@/components/InputNumber.vue";

const store = useStore()

const formData = ref({
  label: "",
  name: "",
  type: "",
  order: "",
  answer_type_id: null,
  required: true,
  negative: false,
  qvct_survey_category_id: [],
})

const formEditData = ref({
  id: "",
  label: "",
  name: "",
  type: "",
  order: "",
  answer_type_id: null,
  required: true,
  negative: false,
  qvct_survey_category_id: [],
})

const showOpt = computed(() =>  formData.value.type === 'radio')
const showEditOpt = computed(() =>  formEditData.value.type === 'radio')

watch(() => formData.value.label, () => {
  formData.value.name = slugify(formData.value.label)
})

watch(() => showOpt.value, () => {
  if(showOpt.value === false) {
    formData.value.answer_type_id = null
  }
})

const route = useRoute()
const router = useRouter()
const file = ref('')
const type = ref('')
const isLoading = ref(false)



const survey = computed(() => store.getters['qvctSurvey/getQvctSurvey'](route.params.id))

const categoriesWithoutChildren = computed(() => store.getters['qvctSurvey/getQvctServeysCategoriesWithoutChildren'])
const questions = computed(() => store.getters['qvctSurvey/loadQuestions'](route.params.id))
const answersTypes = computed(() => store.getters['qvctSurvey/getQvctServeysAnswersType'])

const categoriesOptionGroup = computed(() => {
  let options = {}

  categoriesWithoutChildren.value.forEach((category) => {
    let id = category.parent_id || category.id
    let option = options[id]

    if(!option) {
      option = {
        id: id,
        title: category.parent ? category.parent.name : category.name,
        parent_type: category.parent_type.value,
        parent_type_title: category.parent_type[locale.value],
        data: []
      }
    }

    option.data.push(category)

    options = {...options, [id]: option}
  })

  return options
})

function reloadFormData() {
  formData.value = {
    label: "",
    name: "",
    type: "",
    order: "",
    answer_type_id: null,
    required: true,
    qvct_survey_category_id: [],
  }
}

function editField(question) {
  formEditData.value.id = question.id
  formEditData.value.label = question.label
  formEditData.value.name = question.name
  formEditData.value.type = question.type
  formEditData.value.order = question.order
  formEditData.value.required = question.required
  formEditData.value.negative = question.negative
  formEditData.value.answer_type_id = question.answer_type_id
  formEditData.value.qvct_survey_category_id = question.categories.map(x => x.id)

  $('#editQuestionModal').modal('show')
}

function submitQuestion() {
  isLoading.value = true

  let data = {
    qvct_survey_id: route.params.id,
    fields: [
      formData.value
    ]
  }

  store.dispatch('qvctSurvey/storeQuestion', data)
      .then(() => {
        window.toastr.success(i18n.global.t('qvct_survey.message.question_updated_successfully'))
        isLoading.value = false
        loadData()
        $('#createQuestionModal').modal('hide')
      })
      .catch(() => {
        isLoading.value = false
      })
}

function updateQuestion() {
  isLoading.value = true

  let data = {
    qvct_survey_id: route.params.id,
    fields: [
      formEditData.value
    ]
  }

  store.dispatch('qvctSurvey/updateQuestion', {
    id: formEditData.value.id,
    data: formEditData.value
  })
      .then(() => {
        window.toastr.success(i18n.global.t('qvct_survey.message.question_updated_successfully'))
        isLoading.value = false
        loadData()
        $('#editQuestionModal').modal('hide')
      })
      .catch(() => {
        isLoading.value = false
      })
}


function loadData() {
  if(route.params.id) {
    Promise.all([
      store.dispatch('qvctSurvey/loadQuestions',route.params.id),
    ])
  }
}


onMounted(() => {
  loadData()
})



function closeModal(){
  $('#importQuestionModal').modal('toggle')
}

const onQuestionFileChange = (event) => {
  file.value = event.target.files[0];
}

const importQuestion = async () => {
  type.value = 'import'
  isLoading.value = true
  let response
  try {

    let data = {
      qvct_survey_id:route.params.id,
      file:file.value
    }

    const formDataFile = createFormData(data);

    await store.dispatch('qvctSurvey/importQuestion',formDataFile)
    type.value = 'export'

    $('#importQuestionModal').modal('hide')
    isLoading.value = false
    loadData()
    window.toastr['success'](i18n.global.t('notification.question_imported'))
  } catch (e) {
    isLoading.value = false
    if (response && response.data) {
      window.toastr['error'](response.data.message)
    }
  }
}

const downloadExcel = async () => {
  try {
    isLoading.value = true
    const downloadLink = document.createElement('a');
    downloadLink.href = '/assets/media/excel/Fichier_modele_questionnaire_qvct.xlsx';
    downloadLink.download = 'Fichier_modele_questionnaire_qvct.xlsx';
    downloadLink.click();
  } catch (e) { }
  isLoading.value = false
}
</script>